/**
 * El terminal_token es un secreto de instalacion, por maquina. Se obtiene una
 * sola vez con GET /terminal-token (requiere access_token de admin) y NO se
 * puede recuperar despues: la BD solo guarda su SHA-256. Repetir la llamada
 * con el mismo `code` rota el token y tumba al TPV que lo estuviera usando.
 *
 * Se da de alta en el primer arranque: TerminalGate pide el codigo (en codigo
 * de barras), AuthService.validateTerminalToken lo comprueba y setTerminalToken
 * lo guarda. Desde entonces no se vuelve a pedir. Para repetir el alta en una
 * maquina hay que borrar la clave tpv_terminal_token del localStorage.
 */
const STORAGE_KEY = 'tpv_terminal_token';
const SERIES_STORAGE_KEY = 'tpv_ticket_series';

/** Codigo guardado en esta maquina, o '' si el TPV aun no esta dado de alta. */
export const getTerminalToken = (): string => {
  try {
    return localStorage.getItem(STORAGE_KEY) || '';
  } catch {
    return '';
  }
};

export const setTerminalToken = (token: string): void => {
  try {
    localStorage.setItem(STORAGE_KEY, token);
    // Otro codigo puede ser de otra tienda: la serie recordada ya no vale.
    localStorage.removeItem(SERIES_STORAGE_KEY);
  } catch { /* sin persistencia: se pedira de nuevo al recargar */ }
};

/** Evento que avisa a TerminalGate de que el codigo guardado se ha descartado. */
export const TERMINAL_CLEARED_EVENT = 'tpv-terminal-cleared';

/** Descarta el codigo guardado (fallo de conexion con el) y obliga a pedirlo de nuevo. */
export const clearTerminalToken = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch { /* sin persistencia: no hay nada que borrar */ }
  window.dispatchEvent(new Event(TERMINAL_CLEARED_EVENT));
};

export const isTerminalProvisioned = (): boolean => getTerminalToken() !== '';

const WAREHOUSE_STORAGE_KEY = 'tpv_warehouse_id';

export const getWarehouseId = (): string => {
  try {
    return localStorage.getItem(WAREHOUSE_STORAGE_KEY) || '';
  } catch {
    return '';
  }
};

/**
 * Serie del ultimo ticket de este TPV, tal como la devolvio el servidor. Solo sirve para
 * reconocer un numero suelto al buscar un ticket: NUNCA se envia al crear, la serie la
 * decide el servidor a partir de la tienda del terminal.
 */
export const getTicketSeries = (): string => {
  try {
    return localStorage.getItem(SERIES_STORAGE_KEY) || '';
  } catch {
    return '';
  }
};

export const setTicketSeries = (series: string): void => {
  try {
    localStorage.setItem(SERIES_STORAGE_KEY, series);
  } catch { /* sin persistencia: se usa la serie por defecto */ }
};

/** Con '' se borra el almacen guardado: no puede quedar el de otro terminal. */
export const setWarehouseId = (id: string): void => {
  try {
    if (id) {
      localStorage.setItem(WAREHOUSE_STORAGE_KEY, id);
    } else {
      localStorage.removeItem(WAREHOUSE_STORAGE_KEY);
    }
  } catch { /* sin persistencia: se consultara sin filtro de almacen */ }
};
